import {EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';

/**
 * Компонент для элемента списочного постраничного представления сущностей
 */
export abstract class ListItemComponent implements OnInit, OnDestroy {

    @Input() abstract item: any;
    @Input() abstract selectedValues: any;

    @Input() isFetching = false;
    @Input() canBeSelected = true;

    @Output() selectionChanges = new EventEmitter();

    ngOnInit(): void {

    }

    ngOnDestroy(): void {

    }

}
